import { Avatar, Box, Slide, Tooltip, Typography } from '@mui/material';
import AddIcon from '@mui/icons-material/Add';
import CloseIcon from '@mui/icons-material/Close';
import MenuIcon from '@mui/icons-material/Menu';
import React, { useCallback, useEffect, useMemo, useRef, useState } from 'react';
import useControlledNavigation from '../../hooks/useControlledNavigation';
import { useLocation } from 'react-router-dom';
import FullscreenButton from '../Buttons/FullSceenBtn';
import { useDispatch, useSelector } from 'react-redux';
import { setIsMobileZoom } from '../../redux/reducers/controllNavigation';

const BottomNavBarMobileTab = () => {
  const [activeSubNav, setActiveSubNav] = useState('');
  const [activeNav, setActiveNav] = useState('');
  const [overflowMenuOpen, setOverflowMenuOpen] = useState(false);
  const [reportOptions, setReportOptions] = useState(false);
  const [isMuiModalOpen, setIsMuiModalOpen] = useState(false);
  const [canScrollLeft, setCanScrollLeft] = useState(false);
  const [canScrollRight, setCanScrollRight] = useState(false);
  const navScrollRef = useRef(null);
  const navigate = useControlledNavigation();
  const location = useLocation();

  console.log(activeSubNav, '@@@@@@@@@@@@@activeSubNav');

  useEffect(() => {
    const currentPath = location.pathname + location.search;

    console.log(currentPath, '@@@@@@@@@@@@@currectpath');

    // Handle dashboard/home route
    if (currentPath === '/') {
      setActiveNav('/?active=Business_Overview');
      setActiveSubNav('');
      return;
    }

    const matchedMenu = currentPath.includes('reports/')
      ? menus.find((item) => item.mainNav === '/reports')
      : menus.find((item) => currentPath === item.subNav || currentPath === item.mainNav);

    if (!matchedMenu) {
      setActiveNav('');
      setActiveSubNav('');
      return;
    }

    const isReportsRoute = matchedMenu.mainNav === '/reports' && currentPath.startsWith('/reports/');
    if (isReportsRoute) {
      setActiveNav('/reports');
      setActiveSubNav(currentPath);
      return;
    }

    const isSubNavPath = currentPath === matchedMenu.subNav;
    const isMainNavPath = currentPath === matchedMenu.mainNav;
    const samePath = matchedMenu.mainNav === matchedMenu.subNav;

    if (isSubNavPath && !samePath) {
      setActiveSubNav(matchedMenu.subNav);
      setActiveNav('');
    } else if (isMainNavPath || samePath) {
      setActiveNav(matchedMenu.mainNav);
      setActiveSubNav('');
    }
  }, [location]);

  const iconStyle = useMemo(
    () => ({
      color: '#ffffff',
      fontSize: '10px',
      fontWeight: 'bold',
      borderRadius: '4px',
      height: '14px',
      width: '25px',
      backgroundColor: '#911B7C',
    }),
    []
  );

  const menus = useMemo(
    () => [
      {
        menu: 'home',
        title: 'BizView',
        mainNav: '/?active=Business_Overview',
        tooltip: '',
        toolTipMain: '',
        // icon: <Avatar variant="rounded" sx={{ color: state.openMenu.dashboard && (state.selectMenu == 'dashboard') ? '#ffffff' : '#ffffff', fontSize: '12px', fontWeight: 'bold', backgroundColor: 'rgb(255 255 255 / 20%)', borderRadius: '3px', height: '30px', width: '30px' }}>DaB</Avatar>,
        icon: (
          //   <Avatar variant="rounded" sx={iconStyle}>
          //     DaB
          //   </Avatar>
          <img src="/dashboard.png" alt="Dashboard" style={{ width: '25px', height: '25px' }} />
        ),
        //   submenuColor:theme.palette.secondary.main,
        submenus: [],
        nav: '/',
      },
      {
        menu: 'inventory',
        title: 'Items',
        mainNav: '/newItemList',
        subNav: '/additem',
        subNAvIcon: (
          <AddIcon
            sx={{
              background: 'transparent',
              width: '12px',
              height: '12px',
              color: '#fb3b6fff',
              borderRadius: '2px',
            }}
          />
        ),
        //   subNavDisabled: Freeze,
        tooltip: 'Add Item',
        toolTipMain: 'View Item List',
        icon: (
          <Avatar variant="rounded" sx={iconStyle}>
            Itm
          </Avatar>
        ),
        //   submenuColor:theme.palette.secondary.main,
        submenus: [],
      },
      {
        menu: 'customer',
        title: 'Customer',
        mainNav: '/customerList',
        subNav: '/addcustomer',
        subNAvIcon: (
          <AddIcon
            sx={{
              background: 'transparent',
              width: '12px',
              height: '12px',
              color: '#fb3b6fff',
              borderRadius: '2px',
            }}
          />
        ),
        //   subNavDisabled: Freeze,
        tooltip: 'Add Customer',
        toolTipMain: 'View Customer List',
        icon: (
          <Avatar variant="rounded" sx={iconStyle}>
            Cus
          </Avatar>
        ),
        submenus: [],
        //   submenuColor:cousColor,
      },
      {
        menu: 'Sales',
        title: 'Sales',
        mainNav: '/salesInvoiceReport',
        subNav:
          // gstStatus == 1 ? "/addinvoiceNonTaxable" : "/addinvoiceTaxable",
          '/addnewinvoicetax',
        //   subNavDisabled: Freeze,
        subNAvIcon: (
          <AddIcon
            sx={{
              background: 'transparent',
              width: '12px',
              height: '12px',
              color: '#fb3b6fff',
              borderRadius: '2px',
            }}
          />
        ),
        toolTipMain: 'View Sales Invoice List',
        tooltip: 'Add Invoice',
        icon: (
          <Avatar variant="rounded" sx={iconStyle}>
            Sinv
          </Avatar>
        ),
        submenus: [],
        //   submenuColor:cousColor,
      },
      {
        menu: 'POS',
        title: 'POS',
        mainNav: '/allpos',
        subNav: '/newpos',
        subNAvIcon: (
          <AddIcon
            sx={{
              background: 'transparent',
              width: '12px',
              height: '12px',
              color: '#fb3b6fff',
              borderRadius: '2px',
            }}
          />
        ),
        //   subNavDisabled: Freeze,
        toolTipMain: 'View POS Invoice List',
        tooltip: 'Add Pos',
        icon: (
          <Avatar variant="rounded" sx={iconStyle}>
            Pos
          </Avatar>
        ),
        submenus: [],
        //    submenuColor:cousColor,
      },
      {
        menu: 'receipts',
        title: 'Receipts',
        mainNav: '/receipts',
        subNav: '/addreceipts',
        subNAvIcon: (
          <AddIcon
            sx={{
              background: 'transparent',
              width: '12px',
              height: '12px',
              color: '#fb3b6fff',
              borderRadius: '2px',
            }}
          />
        ),
        //   subNavDisabled: Freeze,
        tooltip: 'Add Receipts',
        toolTipMain: 'View Receipt List',
        icon: (
          <Avatar variant="rounded" sx={iconStyle}>
            Rec
          </Avatar>
        ),
        submenus: [
          // {
          //   name: 'Receipts',
          //   nav: '/receipts'
          // },
          // {
          //   name: 'Add Receipts',
          //   nav: '/addreceipts'
          // },
        ],
        //    submenuColor:cousColor,
      },
      {
        menu: 'supplier',
        title: 'Supplier',
        mainNav: '/supplierList',
        subNav: '/addsupplier',
        subNAvIcon: (
          <AddIcon
            sx={{
              background: 'transparent',
              width: '12px',
              height: '12px',
              color: '#fb3b6fff',
              borderRadius: '2px',
            }}
          />
        ),
        //   subNavDisabled: Freeze,
        tooltip: 'Add Supplier',
        toolTipMain: 'View Supplier List',
        icon: (
          <Avatar
            variant="rounded"
            sx={iconStyle}
            // sx={menuStyle}
          >
            Sup
          </Avatar>
        ),
        submenus: [],
        //   submenuColor:supColor,
      },
      {
        menu: 'Purchase Invoices',
        title: 'Purchase',
        mainNav: '/allpurchaseandexpense',
        subNav:
          // gstStatus == 1
          //   ? "/addpurchaseandexpensenontaxable"
          //   : "/addpurchaseandexpensetaxable",
          '/addnewpurchasetax',
        //   subNavDisabled: Freeze,
        subNAvIcon: (
          <AddIcon
            sx={{
              background: 'transparent',
              width: '12px',
              height: '12px',
              color: '#fb3b6fff',
              borderRadius: '2px',
            }}
          />
        ),
        toolTipMain: 'View Purchase Invoice List',
        tooltip: 'Add Purchase Invoice',
        icon: (
          <Avatar variant="rounded" sx={iconStyle}>
            Pinv
          </Avatar>
        ),
        submenus: [],
        //   submenuColor:supColor,
      },
      {
        menu: 'payments',
        title: 'Payments',
        mainNav: '/paymententries',
        subNav: '/addpaymententries',
        subNAvIcon: (
          <AddIcon
            sx={{
              background: 'transparent',
              width: '12px',
              height: '12px',
              color: '#fb3b6fff',
              borderRadius: '2px',
            }}
          />
        ),
        //   subNavDisabled: Freeze,
        tooltip: 'Add Payment',
        toolTipMain: 'View Payment List',
        icon: (
          <Avatar variant="rounded" sx={iconStyle}>
            Pay
          </Avatar>
        ),
        submenus: [
          // {
          //   name: 'Payment Entries',
          //   nav: '/paymententries'
          // },
          // {
          //   name: 'Add Payment Entries',
          //   nav: '/addpaymententries'
          // },
        ],
        //   submenuColor:supColor,
      },
      {
        menu: 'Debit Note /Purchase Return',
        title: 'Debit Note',
        mainNav: '/alldebitnote',
        subNav: '/adddebitnote',
        subNAvIcon: (
          <AddIcon
            sx={{
              background: 'transparent',
              width: '12px',
              height: '12px',
              color: '#fb3b6fff',
              borderRadius: '2px',
            }}
          />
        ),
        //   subNavDisabled: Freeze,
        tooltip: 'Add Debit Note',
        toolTipMain: 'View Debit Note List',
        icon: (
          <Avatar variant="rounded" sx={iconStyle}>
            Drn
          </Avatar>
        ),
        submenus: [],
        //   submenuColor:dbnColor,
      },
      {
        menu: 'Credit Note / Sales Return',
        title: 'Credit Note',
        mainNav: '/allcreditnote',
        subNav: '/addcreditnote',
        subNAvIcon: (
          <AddIcon
            sx={{
              background: 'transparent',
              width: '12px',
              height: '12px',
              color: '#fb3b6fff',
              borderRadius: '2px',
            }}
          />
        ),
        //   subNavDisabled: Freeze,
        tooltip: 'Add Credit Note',
        toolTipMain: 'View Credit Note List',
        icon: (
          <Avatar variant="rounded" sx={iconStyle}>
            Crn
          </Avatar>
        ),
        submenus: [],
        //   submenuColor:dbnColor,
      },
      {
        menu: 'Journal Entries',
        title: 'Journal',
        mainNav: '/journalentries',
        subNav: '/addjournalentry',
        subNAvIcon: (
          <AddIcon
            sx={{
              background: 'transparent',
              width: '12px',
              height: '12px',
              color: '#fb3b6fff',
              borderRadius: '2px',
            }}
          />
        ),
        //   subNavDisabled: Freeze,
        tooltip: 'Add Journal Entries',
        toolTipMain: 'View Journal Entries List',
        icon: (
          <Avatar variant="rounded" sx={iconStyle}>
            JV
          </Avatar>
        ),
        submenus: [],
        //   submenuColor:jvColor,
      },
      {
        menu: 'Opening Balance',
        title: 'Op. Bal.',
        mainNav: '/openingbalance',
        subNav: '/openingbalance',
        subNAvIcon: (
          <AddIcon
            sx={{
              background: 'transparent',
              width: '12px',
              height: '12px',
              color: '#fb3b6fff',
              borderRadius: '2px',
            }}
          />
        ),
        //   subNavDisabled: Freeze,
        tooltip: 'Add Opening Balance',
        toolTipMain: 'View Opening Balance List',
        icon: (
          <Avatar variant="rounded" sx={iconStyle}>
            OpB
          </Avatar>
        ),
        submenus: [],
        //   submenuColor:jvColor,
      },

      {
        menu: 'profitAndLose',
        title: 'P&L',
        mainNav: '/?active=ProfitAndLoss',
        tooltip: '',
        toolTipMain: '',
        icon: <img src="/PL.png" alt="P&L" style={{ width: '30px', height: '30px' }} />,
        submenus: [],
      },
      {
        menu: 'balanceSheet',
        title: 'Balance Sheet',
        mainNav: '/?active=BalanceSheet',
        tooltip: '',
        toolTipMain: '',
        icon: <img src="/BS.png" alt="BS" style={{ width: '30px', height: '30px' }} />,
        submenus: [],
      },
      {
        menu: 'reports',
        title: 'Reports',
        mainNav: '/reports',
        tooltip: '',
        toolTipMain: 'View Reports',
        icon: <img src="/ACC.png" alt="Accounts" style={{ width: '30px', height: '30px' }} />,
        submenus: [],
      },
      {
        menu: 'trialBalance',
        title: 'Trial Balance',
        mainNav: '/?active=TrialBalance',
        tooltip: '',
        toolTipMain: '',
        icon: <img src="/trialBakl.png" alt="BS" style={{ width: '30px', height: '30px' }} />,
        submenus: [],
      },
      {
        menu: 'tradeRecivable',
        title: 'Trade Receivables',
        mainNav: '/?active=Receivables',
        tooltip: '',
        toolTipMain: '',
        icon: <img src="/tradeRec.png" alt="BS" style={{ width: '30px', height: '30px' }} />,
        submenus: [],
      },
      {
        menu: 'tradePayable',
        title: 'Trade Payables',
        mainNav: '/?active=Payables',
        tooltip: '',
        toolTipMain: '',
        icon: <img src="/TradePay.png" alt="BS" style={{ width: '30px', height: '30px' }} />,
        submenus: [],
      },
      {
        menu: 'item',
        title: 'Item',
        mainNav: '/?active=Items',
        tooltip: '',
        toolTipMain: '',
        icon: <img src="/itemz.png" alt="BS" style={{ width: '30px', height: '30px' }} />,
        submenus: [],
      },
      {
        menu: 'accounts',
        title: 'Accounts',
        mainNav: '/accounts',
        subNav: '/',
        toolTipMain: 'View Accounts ',
        tooltip: '',
        icon: (
          <Avatar variant="rounded" sx={iconStyle}>
            Acc
          </Avatar>
        ),
        submenus: [],
      },
    ],
    []
  );

  const reportOptiond = useMemo(
    () => [
      { item: 'cashBank', label: 'Bank/Cash Book', nav: '/reports/1' },
      { item: 'allLedgers', label: 'All Ledgers', nav: '/reports/3' },
      { item: 'dayBook', label: 'Day Book', nav: '/reports/4' },

      { item: 'TCS Payable Reports', label: 'TCS Payable Reports', nav: '/reports/5?ids=01' },
      { item: 'TCS Receivable Reports', label: 'TCS Receivable Reports', nav: '/reports/5?ids=02' },
      { item: 'TDS Payable Reports', label: 'TDS Payable Reports', nav: '/reports/5?ids=03' },
      { item: 'TDS Receivable Reports', label: 'TDS Receivable Reports', nav: '/reports/5?ids=04' },

      { item: 'EwayBillList', label: 'Eway Bill List', nav: '/reports/6?ids=004' },
      { item: 'GSTR1', label: 'GSTR 1', nav: '/reports/6?ids=001' },
      { item: 'GSTR3B', label: 'GSTR 3B', nav: '/reports/6?ids=003' },

      { item: 'payable', label: 'Payable', nav: '/reports/7?ids=030' },
      { item: 'payableAging', label: 'Payable Ageing', nav: '/reports/7?ids=040' },
      { item: 'Receivable', label: 'Receivable', nav: '/reports/7?ids=010' },
      { item: 'ReceivableAgeing', label: 'Receivable Ageing', nav: '/reports/7?ids=020' },

      { item: 'stockanditem', label: 'Stock & Item waise P&L', nav: '/reports/9?ids=101' },
      { item: 'StockLedger', label: 'Stock Ledger', nav: '/reports/9?ids=102' },
    ],
    []
  );

  const mainMenuItems = useMemo(() => menus.filter((item) => !item.subNav).slice(0, 9), [menus]);

  const overflowMenuItems = useMemo(() => menus.filter((item) => item.subNav), [menus]);
  const dispatch = useDispatch();

  const handleOverflowItemClick = (e, item) => {
    e?.preventDefault?.();
    e?.stopPropagation?.();
    if (item?.mainNav) {
      navigate(item.mainNav);
      setOverflowMenuOpen(false);
      setReportOptions(false);
    }
  };

  const handleReportItemClick = (e, item) => {
    e?.preventDefault?.();
    e?.stopPropagation?.();
    if (item?.nav) {
      navigate(item.nav);
      setReportOptions(false);
    }
  };

  const toggleOverflowMenu = () => {
    setReportOptions(false);
    setOverflowMenuOpen((prev) => !prev);
  };

  const toggleReportOptions = () => {
    setOverflowMenuOpen(false);
    setReportOptions((prev) => !prev);
  };

  const closeAllPanels = () => {
    setOverflowMenuOpen(false);
    setReportOptions(false);
  };

  const updateNavScrollIndicators = useCallback(() => {
    const el = navScrollRef.current;
    if (!el) return;

    const { scrollLeft, scrollWidth, clientWidth } = el;
    const maxScrollLeft = scrollWidth - clientWidth;
    const epsilon = 2;

    setCanScrollLeft(scrollLeft > epsilon);
    setCanScrollRight(maxScrollLeft > epsilon && scrollLeft < maxScrollLeft - epsilon);
  }, []);

  const scrollNavBy = useCallback((direction) => {
    const el = navScrollRef.current;
    if (!el) return;
    el.scrollBy({ left: direction * Math.max(80, el.clientWidth * 0.35), behavior: 'smooth' });
  }, []);

  const isNavScrollable = canScrollLeft || canScrollRight;

  useEffect(() => {
    const el = navScrollRef.current;
    if (!el) return;

    updateNavScrollIndicators();

    const handleScroll = () => updateNavScrollIndicators();
    el.addEventListener('scroll', handleScroll, { passive: true });

    const resizeObserver = typeof ResizeObserver !== 'undefined' ? new ResizeObserver(updateNavScrollIndicators) : null;
    resizeObserver?.observe(el);

    window.addEventListener('resize', updateNavScrollIndicators);

    return () => {
      el.removeEventListener('scroll', handleScroll);
      resizeObserver?.disconnect();
      window.removeEventListener('resize', updateNavScrollIndicators);
    };
  }, [updateNavScrollIndicators, mainMenuItems]);

  const handleOverflowSubNavClick = (e, item) => {
    e?.preventDefault?.();
    e?.stopPropagation?.();
    if (item?.subNav) {
      navigate(item.subNav);
      setOverflowMenuOpen(false);
    }
  };

  // Redux state flag (not the action)
  const setIsAnyModalOpen = useSelector((state) => state?.controllNavigationSlice?.setIsAnyModalOpen);

  useEffect(() => {
    const checkModalOpen = () => {
      const hasOpenMuiModal =
        Boolean(document.querySelector('.MuiModal-root')) ||
        Boolean(document.querySelector('.MuiDialog-root')) ||
        Boolean(document.querySelector('[role="dialog"]'));
      setIsMuiModalOpen(hasOpenMuiModal);
    };

    checkModalOpen();
    const observer = new MutationObserver(checkModalOpen);
    observer.observe(document.body, { childList: true, subtree: true });

    return () => observer.disconnect();
  }, []);

  const isAnyModalOpen = Boolean(setIsAnyModalOpen || isMuiModalOpen);
  const isAnyPanelOpen = overflowMenuOpen || reportOptions;
  const navLayerBaseZIndex = isAnyPanelOpen ? 1400 : isAnyModalOpen ? 100 : 3000;

  const renderNavItem = (item, index) => (
    <Box
      key={index}
      sx={{ pointerEvents: 'auto', height: '100%', flexShrink: 0 }}
      onClick={(e) => {
        e.preventDefault();

        if (item?.title === 'Reports') {
          toggleReportOptions();
          return;
        }

        if (item?.mainNav) {
          closeAllPanels();
          navigate(item.mainNav);
        }
      }}
    >
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'center',
          alignItems: 'center',
          height: '100%',
          gap: '2px',
        }}
      >
        {/* <Box
          sx={{
            height: '40%',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            marginBottom: item?.subNav?.length > 0 ? '5px' : '30px',
          }}
        >
          {item?.subNav?.length > 0 ? (
            <Tooltip title={item.tooltip} placement="top">
              <Box
                onClick={(e) => {
                  e.preventDefault();
                  navigate(item.subNav);
                }}
                sx={{
                  width: '22px',
                  height: '22px',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  borderRadius: '50%',
                  cursor: 'pointer',
                  border: activeSubNav === item.subNav ? '1px solid #fb3b6fff' : '2px solid transparent',
                }}
              >
                {item.subNAvIcon}
              </Box>
            </Tooltip>
          ) : null}
        </Box> */}
        <Box
          sx={{
            display: 'inline-flex',
            '& img': {
              transition: 'filter 0.2s ease',
              width: '18px !important',
              height: '18px !important',
              filter:
                activeNav === item.mainNav
                  ? 'brightness(0) saturate(100%) invert(39%) sepia(91%) saturate(2924%) hue-rotate(321deg)'
                  : 'none',
            },
            '& .MuiAvatar-root': {
              transition: 'box-shadow 0.2s ease, background-color 0.2s ease',
              ...(activeNav === item.mainNav && {
                boxShadow: '0 0 0 2px #fb3b6f',
                backgroundColor: 'rgba(251, 59, 111, 0.85)',
              }),
            },
          }}
        >
          {item.icon}
        </Box>

        <Box
          sx={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            textWrap: 'nowrap',
          }}
        >
          <Typography
            sx={{
              fontSize: '11px !important',
              fontWeight: 700,
              lineHeight: 1,
              cursor: item.mainNav ? 'pointer' : 'default',
              letterSpacing: '0.4px',
              color: activeNav === item.mainNav ? '#fb3b6f' : '#333',
              textShadow: activeNav === item.mainNav ? '0 1px 2px rgba(251,59,111,0.25)' : '0 1px 1px rgba(0,0,0,0.15)',
              transition: 'all 0.2s ease',
              whiteSpace: 'nowrap',
            }}
          >
            {item.title}
          </Typography>
        </Box>
      </Box>
    </Box>
  );

  return (
    <Box
      sx={{
        position: 'fixed',
        bottom: 3,
        left: 5,
        right: 5,
        zIndex: navLayerBaseZIndex,
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'flex-end',
        borderRadius: '50px',
      }}
    >
      {/* Backdrop - closes open panels when clicking outside */}
      {isAnyPanelOpen && (
        <Box
          onClick={closeAllPanels}
          sx={{
            position: 'fixed',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            backgroundColor: 'rgba(0,0,0,0.15)',
            zIndex: 0,
            animation: 'fadeIn 0.2s ease-out',
            '@keyframes fadeIn': {
              from: { opacity: 0 },
              to: { opacity: 1 },
            },
          }}
        />
      )}

      {/* Overflow menu card - appears above the main nav bar with slide animation */}
      <Box
        sx={{
          position: 'absolute',
          bottom: '100%',
          left: 10,
          right: 10,
          mb: '-2px',
          overflow: 'hidden',
          zIndex: 2,
          pointerEvents: overflowMenuOpen ? 'auto' : 'none',
        }}
      >
        <Slide
          in={overflowMenuOpen}
          direction="up"
          timeout={{
            enter: 300,
            exit: 250,
          }}
          mountOnEnter
          unmountOnExit
        >
          <Box
            sx={{
              position: 'relative',
              backgroundColor: 'rgb(255, 252, 252)',
              backdropFilter: 'blur(8px)',
              WebkitBackdropFilter: 'blur(8px)',
              borderRadius: '12px',
              boxShadow: '0 -4px 20px rgba(0,0,0,0.12)',
              padding: '15px',
            }}
          >
            <Box
              sx={{
                maxHeight: '40vh',
                overflowX: 'hidden',
                overflowY: 'auto',
                display: 'grid',
                gridTemplateColumns: 'repeat(3, minmax(0, 1fr))',
                gap: '15px',
                pb: '64px', // space for fixed fullscreen button
                /* hide scrollbar */
                scrollbarWidth: 'none',
                '&::-webkit-scrollbar': { display: 'none' },
              }}
            >
              {overflowMenuItems.map((item, index) => (
                <Box
                  key={index}
                  onClick={(e) => handleOverflowItemClick(e, item)}
                  sx={{
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    justifyContent: 'center',
                    gap: '15px',
                    padding: '15px',
                    borderRadius: '8px',
                    cursor: 'pointer',
                    minWidth: 0,
                    WebkitTapHighlightColor: 'transparent',
                    outline: 'none',
                    '&:hover': { backgroundColor: 'rgba(0,0,0,0.04)' },
                    '&:active': { backgroundColor: 'transparent' },
                    transition: 'background-color 0.2s',
                  }}
                >
                  {item.subNAvIcon && (
                    <Tooltip title={item.tooltip} placement="top">
                      <Box
                        onClick={(e) => handleOverflowSubNavClick(e, item)}
                        sx={{
                          width: '16px',
                          height: '16px',
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'center',
                          borderRadius: '50%',
                          cursor: 'pointer',
                          WebkitTapHighlightColor: 'transparent',
                          outline: 'none',
                          border: '1px solid,',
                          borderColor: activeSubNav === item.subNav ? ' #fb3b6fff' : 'black',
                          backgroundColor: activeSubNav === item.subNav ? 'rgba(251, 59, 111, 0.1)' : 'transparent',
                        }}
                      >
                        {item.subNAvIcon}
                      </Box>
                    </Tooltip>
                  )}
                  <Typography
                    component="span"
                    sx={{
                      fontSize: '12px !important',
                      fontWeight: 'bold',
                      //   fontWeight: activeNav === item.mainNav ? 700 : 600,
                      border: 'solid 1px',
                      padding: 1,
                      borderRadius: '8px',
                      color: activeNav === item.mainNav ? '#fb3b6fff' : '#333',
                      lineHeight: 1,
                      textAlign: 'center',
                      //   userSelect: 'none',
                      whiteSpace: 'nowrap',
                      overflow: 'hidden',
                      textOverflow: 'ellipsis',
                      width: '100%',
                      minWidth: 0,
                    }}
                  >
                    {item.title}
                  </Typography>
                </Box>
              ))}
            </Box>

            {/* Fixed fullscreen button inside card */}
            <Box
              sx={{
                position: 'absolute',
                right: 12,
                bottom: 12,
                zIndex: 2,
              }}
              onClick={() => dispatch(setIsMobileZoom(true))}
            >
              <FullscreenButton />
            </Box>
          </Box>
        </Slide>
      </Box>

      {/* Reports options panel */}
      <Box
        sx={{
          position: 'absolute',
          bottom: '100%',
          left: 10,
          right: 10,
          mb: '-2px',
          overflow: 'hidden',
          zIndex: 2,
          pointerEvents: reportOptions ? 'auto' : 'none',
        }}
      >
        <Slide
          in={reportOptions}
          direction="up"
          timeout={{
            enter: 300,
            exit: 250,
          }}
          mountOnEnter
          unmountOnExit
        >
          <Box
            sx={{
              position: 'relative',
              backgroundColor: 'rgb(255, 252, 252)',
              backdropFilter: 'blur(8px)',
              WebkitBackdropFilter: 'blur(8px)',
              borderRadius: '12px',
              boxShadow: '0 -4px 20px rgba(0,0,0,0.12)',
              padding: '15px',
            }}
          >
            <Box
              sx={{
                maxHeight: '40vh',
                overflowX: 'hidden',
                overflowY: 'auto',
                display: 'grid',
                gridTemplateColumns: 'repeat(3, minmax(0, 1fr))',
                gap: '15px',
                pb: '16px',
                scrollbarWidth: 'none',
                '&::-webkit-scrollbar': { display: 'none' },
              }}
            >
              {reportOptiond.map((item, index) => (
                <Box
                  key={index}
                  onClick={(e) => handleReportItemClick(e, item)}
                  sx={{
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    justifyContent: 'center',
                    gap: '10px',
                    padding: '5px',
                    borderRadius: '8px',
                    cursor: 'pointer',
                    minWidth: 0,
                    WebkitTapHighlightColor: 'transparent',
                    outline: 'none',
                    '&:hover': { backgroundColor: 'rgba(0,0,0,0.04)' },
                    '&:active': { backgroundColor: 'transparent' },
                    transition: 'background-color 0.2s',
                    border: 'solid 1px',
                    borderColor: activeSubNav === item.nav ? '#fb3b6fff' : '#333',
                    height: 50,
                  }}
                >
                  <Typography
                    component="span"
                    sx={{
                      fontSize: '12px !important',
                      fontWeight: 'bold',
                      color: activeSubNav === item.nav ? '#fb3b6fff' : '#333',
                      lineHeight: 1,
                      textAlign: 'center',
                      whiteSpace: 'nowrap',
                      overflow: 'hidden',
                      textOverflow: 'ellipsis',
                      width: '100%',
                      minWidth: 0,
                    }}
                  >
                    {item.label}
                  </Typography>
                </Box>
              ))}
            </Box>
          </Box>
        </Slide>
      </Box>

      {/* Main nav bar — + centered on top border (half out); custom scroll indicator */}
      <Box
        sx={{
          width: '100%',
          backgroundColor: '#EFEFEF',
          backdropFilter: 'blur(3px)',
          WebkitBackdropFilter: 'blur(3px)',
          padding: '0 8px 4px',
          boxSizing: 'border-box',
          boxShadow: '0 -2px 8px rgba(0,0,0,0.15)',
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'space-around',
          borderTopLeftRadius: '18px',
          borderTopRightRadius: '18px',
          borderRadius: '18px',
          overflow: 'visible',
          position: 'relative',
          zIndex: 3,
          mb: '10px',
          height: 75,
        }}
      >
        {/* Center + / close — half above top border; no outer white ring */}
        <Box
          onClick={toggleOverflowMenu}
          sx={{
            position: 'absolute',
            left: '50%',
            top: 0,
            transform: 'translate(-50%, -50%)',
            zIndex: 5,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            cursor: 'pointer',
            width: 26,
            height: 26,
            borderRadius: '50%',
            backgroundColor: '#fb3b6f',
            boxShadow: '0 2px 8px rgba(251, 59, 111, 0.4)',
            transition: 'transform .2s ease, box-shadow .2s ease',
            '&:active': {
              transform: 'translate(-50%, -50%) scale(0.94)',
            },
          }}
        >
          {overflowMenuOpen ? (
            <CloseIcon sx={{ fontSize: 15, color: 'white', fontWeight: 'bold' }} />
          ) : (
            <AddIcon sx={{ fontSize: 15, color: 'white', fontWeight: 'bold' }} />
          )}
        </Box>

        <Box
          ref={navScrollRef}
          onScroll={updateNavScrollIndicators}
          sx={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-around',
            overflowX: 'auto',
            overflowY: 'hidden',
            whiteSpace: 'nowrap',
            width: '100%',
            height: '56px',
            gap: 2.5,
            px: 1,
            boxSizing: 'border-box',
            scrollbarWidth: 'none',
            msOverflowStyle: 'none',
            '&::-webkit-scrollbar': {
              display: 'none',
            },
          }}
        >
          {mainMenuItems.slice(0, 2).map((item, index) => (
            <Box
              key={index}
              sx={{
                display: 'flex',
                justifyContent: 'center',
                flex: '0 0 auto',
                px: 0.75,
              }}
            >
              {renderNavItem(item, index)}
            </Box>
          ))}

          {/* Spacer under fixed center + so icons don't overlap it */}
          {/* <Box
            aria-hidden
            sx={{
              width: 40,
              minWidth: 40,
              flex: '0 0 40px',
              height: 1,
              pointerEvents: 'none',
            }}
          /> */}

          {mainMenuItems.slice(2, 9).map((item, index) => (
            <Box
              key={index + 2}
              sx={{
                display: 'flex',
                justifyContent: 'center',
                flex: '0 0 auto',
                px: 0.75,
              }}
            >
              {renderNavItem(item, index + 2)}
            </Box>
          ))}
        </Box>

        {/* Scroll position dots — bright when that edge is reached */}
        {isNavScrollable && (
          <Box
            sx={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              gap: 1,
              height: 10,
              width: '100%',
              mb: 0.25,
            }}
          >
            <Box
              onClick={(e) => {
                e.stopPropagation();
                if (canScrollLeft) scrollNavBy(-1);
              }}
              sx={{
                width: 6,
                height: 6,
                borderRadius: '50%',
                flexShrink: 0,
                cursor: canScrollLeft ? 'pointer' : 'default',
                bgcolor: !canScrollLeft ? '#fb3b6f' : 'rgba(251, 59, 111, 0.28)',
                transition: 'background-color 0.2s ease',
              }}
            />
            <Box
              onClick={(e) => {
                e.stopPropagation();
                if (canScrollRight) scrollNavBy(1);
              }}
              sx={{
                width: 6,
                height: 6,
                borderRadius: '50%',
                flexShrink: 0,
                cursor: canScrollRight ? 'pointer' : 'default',
                bgcolor: !canScrollRight ? '#fb3b6f' : 'rgba(251, 59, 111, 0.28)',
                transition: 'background-color 0.2s ease',
              }}
            />
          </Box>
        )}
      </Box>
    </Box>
  );
};

export default BottomNavBarMobileTab;
